import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import router from "@/router";
import Vant from 'vant';
import {closeLoading, DO_NET_URL, toask} from "@/config/config";

Vue.config.productionTip = false
Vue.use(Vant);
new Vue({
  render: h => h(App), router
}).$mount('#app')

/**
 * 获取U盘授权
 */
async function getAccreditToken() {
    await axios.get("http://127.0.0.1:9898/getAccreditToken", {
        headers: {
            'Content-Type': "application/x-www-form-urlencoded",
        }
    }).then(response => {
        localStorage.setItem("accreditToken", response.data.Data)
    }).catch(error => {
        // 处理错误情况
        console.error(error);
    });
}

//上传图片视频请求
export async function axiosFile(url, data, success) {
    //await getAccreditToken()
    axios.post(url, data, {
        headers: {
            token: localStorage.getItem("iwa_token"),
            'timestamp': new Date().getTime(),
            'accreditToken': localStorage.getItem("accreditToken"),
        }
    }).then(response => {
        if (response.data.data == "请登录！") {
            setTimeout(function () {
                router.replace('index')
            }, 600);
        }else if (response.data.data == "请插入U盘！"||response.data.data == "网关校验失败！") {
            closeLoading()
            toask("请插入U盘！",6)
        } else {
            success && success(response.data);
        }

    }).catch(error => {
        // 处理错误情况
        console.error(error);
    });
}

//发送POST请求
export async function axiosPost(url, data, success) {
    //await getAccreditToken()
    axios.post(url, data, {
        headers: {
            token: localStorage.getItem("iwa_token"),
            'Content-Type': "application/x-www-form-urlencoded",
            'timestamp': new Date().getTime(),
            'accreditToken': localStorage.getItem("accreditToken"),
        }
    }).then(response => {
        if (response.data.data == "请登录！") {
            setTimeout(function () {
                router.replace('index')
            }, 600);
        } else if (response.data.data == "请插入U盘！" || response.data.data == "网关校验失败！") {
            closeLoading()
            toask("请插入U盘！", 6)
        } else {
            success && success(response.data);
        }

    }).catch(error => {
        // 处理错误情况
        console.error(error);
    });
}
//发送post请求（json）
export async function axiosPostJson(url, data, success) {
    //await getAccreditToken()
    axios.post(url, data, {
        headers: {
            token: localStorage.getItem("iwa_token"),
            'Content-Type': "application/json",
            'timestamp': new Date().getTime(),
            'accreditToken': localStorage.getItem("accreditToken"),
        }
    }).then(response => {
        if (response.data.data == "请登录！") {
            setTimeout(function () {
                router.replace('index')
            }, 600);
        }else if (response.data.data == "请插入U盘！"||response.data.data == "网关校验失败！") {
            closeLoading()
            toask("请插入U盘！",6)
        } else {
            success && success(response.data);
        }
    }).catch(error => {
        // 处理错误情况
        console.error(error);
    });
}

//发送GET请求
export async function axiosGet(url, success) {
    //await getAccreditToken()

    axios.get(url, {
        headers: {
            token: localStorage.getItem("iwa_token"),
            'Content-Type': "application/x-www-form-urlencoded",
            'timestamp': new Date().getTime(),
            'accreditToken': localStorage.getItem("accreditToken"),
        }
    }).then(response => {
        if (response.data.data == "请登录！") {
            setTimeout(function () {
                router.replace('index')
            }, 600);
        }else if (response.data.data == "请插入U盘！"||response.data.data == "网关校验失败！") {
            closeLoading()
            toask("请插入U盘！",6)
        } else {
            success && success(response.data);
        }
    }).catch(error => {
        // 处理错误情况
        console.error(error);
    });
}